// Chapter 1 writing frames ("מסגרות"), uploaded 29.10.2026 (Shlomo reviews them live on the site).
// One frame per step; all work on the single event the reader names in step 1.
// Mounted by App.tsx (FrameBox) at <div data-widget-anchor="ch1_fN"> in src/chapters/chapter-1.html.
// Answers persist in progress.fields under `${id}_${i}` (or `_c1`/`_c2` for two columns).
import type { Frame } from "./frames";

export const CH1_FRAMES: Frame[] = [
  {
    "id": "ch1_f1",
    "n": "1.1",
    "title": "הרגע שלי",
    "type": "lines",
    "intro": "עובדות בלבד, בלי פרשנות. אין תשובה נכונה.",
    "fields": [
      "השם שנתתי לו:",
      "מה קרה (מה נאמר, מה נעשה):",
      "מה הגוף עשה (לב, בטן, כתפיים, נשימה):",
      "כששאלתי \"יש כאן אריה, באמת?\" מה קרה:"
    ]
  },
  {
    "id": "ch1_f2",
    "n": "1.2",
    "title": "הפעולות שמזמנות בי רגשות חיוביים",
    "type": "existing",
    "intro": "",
    "fields": [
      "איזו מהשלוש עשיתי באותו שבוע, וכמה זמן לפני הרגע:"
    ]
  },
  {
    "id": "ch1_f3",
    "n": "1.3",
    "title": "אותו רגע, שבועיים אחרי",
    "type": "lines",
    "intro": "בלשון הווה, כאילו זה קורה עכשיו: באותו רגע, שבועיים אחרי הספר...",
    "fields": [
      "מה אני עושה אחרת:",
      "מה הגוף עושה:",
      "מה קורה אחר כך:"
    ]
  },
  {
    "id": "ch1_f4",
    "n": "1.4",
    "title": "לזהות, להבין, לבחור",
    "type": "lines",
    "intro": "",
    "fields": [
      "זיהיתי (שם הרגש):",
      "הבנתי (מאיפה זה בא אצלי):",
      "הייתי בוחרת (מה הייתי עושה אילו היה לי רגע):"
    ]
  },
  {
    "id": "ch1_f5",
    "n": "1.5",
    "title": "המשפט המופרך",
    "type": "lines",
    "intro": "",
    "fields": [
      "הרגש (הענף):",
      "אם זה ימשיך ככה, בסוף... (השורש):"
    ]
  },
  {
    "id": "ch1_f6",
    "n": "1.6",
    "title": "להתאפק או לבדוק",
    "type": "twocol",
    "intro": "",
    "fields": [
      "מה ניסיתי|ביקש ממני להתאפק או לבדוק?",
      "מה ניסיתי|ביקש ממני להתאפק או לבדוק?",
      "מה ניסיתי|ביקש ממני להתאפק או לבדוק?"
    ]
  },
  {
    "id": "ch1_f7",
    "n": "1.7",
    "title": "התכונות שלי, מה חשוב לי, מהו האופי שלי",
    "type": "existing",
    "intro": "",
    "fields": [
      "תכונה שלי שהייתה נוכחת ברגע:",
      "תכונה שלי שנעדרה ממנו:"
    ]
  },
  {
    "id": "ch1_f9",
    "n": "1.9",
    "title": "ההצצה שלי",
    "type": "choice5",
    "intro": "סמני אחת, או כתבי את השישית.",
    "fields": [
      "א קהל · ב כביש · ג כאב · ד אצבע · ה קנאה",
      "ההצצה השישית, שלי:"
    ]
  },
  {
    "id": "ch1_f10",
    "n": "1.10",
    "title": "הרגע שלי, גרסה שנייה",
    "type": "final",
    "intro": "",
    "fields": [
      "מה קרה (שלוש שורות, כפי שאת רואה אותו עכשיו):",
      "",
      "",
      "מה השתנה בין הגרסה הראשונה לשנייה:"
    ]
  }
];
